export type ProductionQuantityUnit = "kg" | "koli" | "adet";

export function productionQuantityUnit(value: string | null | undefined): ProductionQuantityUnit | null {
  const unit = (value ?? "").trim().toLocaleUpperCase("tr-TR");
  if (/^(KG|KİLOGRAM|KILOGRAM)$/u.test(unit)) return "kg";
  if (/^(KOLİ|KOLI|KOLI ADET)$/u.test(unit)) return "koli";
  if (/^(ADET|AD)$/u.test(unit)) return "adet";
  return null;
}

export const productionUnitLabel = (unit: ProductionQuantityUnit) =>
  unit === "kg" ? "kg" : unit === "koli" ? "koli" : "adet";
